import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroCreateContactPopup.SettingsSection', {
    defaultAccountLabel: 'Default account',
    departmentLabel: 'Department',
    regionLabel: 'Region',
    selectPlaceholder: 'Select option',
});
